"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addNewPhoneNumber = addNewPhoneNumber;
exports.changePhoneNumberStandardState = changePhoneNumberStandardState;
exports.default = reducer;
exports.editPhoneNumber = editPhoneNumber;
exports.loadBusinessPartner = loadBusinessPartner;
exports.loadCurrent = loadCurrent;
exports.loadPhoneNumbers = loadPhoneNumbers;
exports.loadTaxVatNumbers = loadTaxVatNumbers;
exports.removePhoneNumber = removePhoneNumber;
exports.saveNewTaxVatData = void 0;
exports.savePersonalData = savePersonalData;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _myDataApi = require("../../api-factory/myDataApi");
var _phoneNumbersApi = require("../../api-factory/phoneNumbersApi");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// Actions
var LOAD_CURRENT_PERSONAL_DATA = 'api/reducer/GET_PERSONAL_DATA';
var SAVE_MY_DATA = 'api/reducer/SAVE_MY_DATA';
var LOAD_BUSINESS_PARTNER = 'api/reducer/LOAD_BUSINESS_PARTNER';
var ADD_NEW_PHONE_NUMBER = 'api/reducer/ADD_NEW_PHONE_NUMBER';
var EDIT_PHONE_NUMBER = 'api/reducer/EDIT_PHONE_NUMBER';
var LOAD_PHONE_NUMBERS = 'api/reducer/LOAD_PHONE_NUMBERS';
var REMOVE_PHONE_NUMBER = 'api/reducer/REMOVE_PHONE_NUMBERS';
var CHANGE_PHONENUMBER_STANDARD_STATE = 'reducer/CHANGE_PHONENUMBER_STANDARD_STATE';
var RESET_PASSWORD_INITIATE = 'api/reducer/RESET_PASSWORD_INITIATE';
var RESET_PASSWORD_VALIDATE = 'api/reducer/RESET_PASSWORD_VALIDATE';
var RESET_PASSWORD_SET = 'api/reducer/RESET_PASSWORD_SET';
var LOAD_TAX_VAT_NUMBERS = 'api/reducer/LOAD_TAX_VAT_NUMBERS';
var SAVE_TAX_DATA = 'api/reducer/SAVE_TAX_DATA';

// Reducer
function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var standardState = state.phoneNumberStandardState ? _objectSpread({}, state.phoneNumberStandardState) : {};
  switch (action.type) {
    case LOAD_CURRENT_PERSONAL_DATA:
      return _objectSpread(_objectSpread({}, state), {}, {
        data: action.data.innerData
      });
    case SAVE_MY_DATA:
      return _objectSpread(_objectSpread({}, state), {}, {
        data: action.data.innerData
      });
    case LOAD_BUSINESS_PARTNER:
      return _objectSpread(_objectSpread({}, state), {}, {
        businessPartner: action.businessPartner
      });
    case LOAD_PHONE_NUMBERS:
      return _objectSpread(_objectSpread({}, state), {}, {
        phoneNumbers: action.phoneNumbers
      });
    case ADD_NEW_PHONE_NUMBER:
      return _objectSpread(_objectSpread({}, state), {}, {
        phoneNumbers: action.phoneNumbers
      });
    case EDIT_PHONE_NUMBER:
      return _objectSpread(_objectSpread({}, state), {}, {
        phoneNumbers: action.phoneNumbers
      });
    case REMOVE_PHONE_NUMBER:
      return _objectSpread(_objectSpread({}, state), {}, {
        phoneNumbers: action.phoneNumbers
      });
    case CHANGE_PHONENUMBER_STANDARD_STATE:
      return _objectSpread(_objectSpread({}, state), {}, {
        phoneNumberStandardState: _objectSpread(_objectSpread({}, standardState), action.value)
      });
    case RESET_PASSWORD_INITIATE:
      return _objectSpread(_objectSpread({}, state), {}, {
        data: action.data.innerData
      });
    case RESET_PASSWORD_VALIDATE:
      return _objectSpread(_objectSpread({}, state), {}, {
        data: action.data.innerData
      });
    case RESET_PASSWORD_SET:
      return _objectSpread(_objectSpread({}, state), {}, {
        data: action.data.innerData
      });
    case LOAD_TAX_VAT_NUMBERS:
      return _objectSpread(_objectSpread({}, state), {}, {
        taxNumbers: action.taxNumbers
      });
    case SAVE_TAX_DATA:
      return _objectSpread(_objectSpread({}, state), {}, {
        taxNumbers: action.taxNumbers
      });
    default:
      return state;
  }
}

// Action Creators
function changePhoneNumberStandardState(dispatch, inputName, isStandard) {
  return dispatch({
    type: CHANGE_PHONENUMBER_STANDARD_STATE,
    value: (0, _defineProperty2.default)({}, inputName, isStandard)
  });
}
function loadCurrent(dispatch, contractId) {
  var resp = (0, _myDataApi.getMyData)(contractId);
  return resp.then(function (reponse) {
    dispatch({
      type: LOAD_CURRENT_PERSONAL_DATA,
      data: {
        innerData: reponse.data
      }
    });
  });
}
function savePersonalData(dispatch, contractId, myData) {
  var resp = (0, _myDataApi.saveMyData)(myData, contractId);
  return resp.then(function (response) {
    dispatch({
      type: SAVE_MY_DATA,
      data: {
        innerData: response.data
      }
    });
  });
}
function loadBusinessPartner(dispatch) {
  var resp = (0, _myDataApi.getBusinessPartner)();
  return resp.then(function (response) {
    dispatch({
      type: LOAD_BUSINESS_PARTNER,
      businessPartner: response.data
    });
  });
}
function loadPhoneNumbers(dispatch, contractId) {
  var resp = (0, _phoneNumbersApi.getPhoneNumbers)(contractId);
  return resp.then(function (response) {
    dispatch({
      type: LOAD_PHONE_NUMBERS,
      phoneNumbers: response.data.content
    });
  });
}
function addNewPhoneNumber(dispatch, phoneNumberObject, contractId) {
  var resp = (0, _phoneNumbersApi.addPhoneNumber)(phoneNumberObject, contractId);
  return resp.then(function (response) {
    dispatch({
      type: ADD_NEW_PHONE_NUMBER,
      phoneNumbers: response.data.content
    });
  }).then(function () {
    loadCurrent(dispatch, contractId);
    loadPhoneNumbers(dispatch, contractId);
  });
}
function editPhoneNumber(dispatch, phoneNumberObject, contractId, index) {
  var resp = (0, _phoneNumbersApi.editPhoneNumbers)(phoneNumberObject, index, contractId);
  return resp.then(function (response) {
    dispatch({
      type: EDIT_PHONE_NUMBER,
      phoneNumbers: response.data.content
    });
  }).then(function () {
    loadCurrent(dispatch, contractId);
    loadPhoneNumbers(dispatch, contractId);
  });
}
function removePhoneNumber(dispatch, contractId, index) {
  var resp = (0, _phoneNumbersApi.deletePhoneNumber)(contractId, index);
  return resp.then(function (response) {
    dispatch({
      type: REMOVE_PHONE_NUMBER,
      phoneNumbers: response.data.content
    });
  }).then(function () {
    loadCurrent(dispatch, contractId);
    loadPhoneNumbers(dispatch, contractId);
  });
}
function loadTaxVatNumbers(dispatch, contractId) {
  var resp = (0, _myDataApi.getTaxVatNumbers)(contractId);
  return resp.then(function (response) {
    dispatch({
      type: LOAD_TAX_VAT_NUMBERS,
      taxNumbers: response.data
    });
  });
}
var saveNewTaxVatData = exports.saveNewTaxVatData = function saveNewTaxVatData(dispatch, id, data) {
  return (0, _myDataApi.saveTaxVatNumber)(id, data).then(function (response) {
    dispatch({
      type: SAVE_TAX_DATA,
      taxNumbers: response.data
    });
  }).catch(function (err) {
    var error = err && err.data && err.data.errors;
    throw error;
  });
};